import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { billingApi, type Subscription } from "@/lib/api";

export default function BillingSuccessPage() {
  const [subscription, setSubscription] = useState<Subscription | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // PayFast's ITN can arrive a few seconds after the redirect — poll briefly
    // for the subscription to flip to active before settling on whatever we have.
    let attempts = 0;
    const poll = () => {
      billingApi
        .subscription()
        .then((res) => {
          setSubscription(res.data);
          attempts += 1;
          if (res.data?.status !== "active" && attempts < 6) {
            setTimeout(poll, 2000);
          } else {
            setLoading(false);
          }
        })
        .catch(() => setLoading(false));
    };
    poll();
  }, []);

  return (
    <div className="min-h-screen bg-background-100 flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-8 text-center">
        <div className="w-16 h-16 rounded-full bg-secondary-50 flex items-center justify-center mx-auto mb-5">
          <i className="ri-checkbox-circle-fill text-secondary-500 text-3xl"></i>
        </div>
        <h1 className="text-foreground-900 text-xl font-bold mb-2">Payment received</h1>
        {loading ? (
          <p className="text-foreground-500 text-sm mb-6">
            <i className="ri-loader-4-line animate-spin mr-1"></i>
            Confirming your subscription…
          </p>
        ) : subscription?.status === "active" ? (
          <p className="text-foreground-500 text-sm mb-6">
            You're now on the <span className="font-semibold">{subscription.plan?.name}</span> plan.
          </p>
        ) : (
          <p className="text-foreground-500 text-sm mb-6">
            Thanks — we're still confirming this with PayFast. It'll reflect on your account shortly.
          </p>
        )}
        <Link to="/" className="inline-flex h-11 px-6 bg-primary-600 hover:bg-primary-700 text-white text-sm font-semibold rounded-lg items-center justify-center transition-colors">
          Go to Dashboard
        </Link>
      </div>
    </div>
  );
}
